export const locales = ['en', 'ko', 'zh-Hant'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

/** The `t` a client component gets from `useTranslations(namespace)`, for
 *  helpers that build text outside a component and are handed it as an argument. */
export type Translator = (key: string, values?: Record<string, string | number>) => string;

// Native display name per locale, keyed as a total Record so adding a locale to
// `locales` is a compile error until its label is supplied.
export const localeLabels: Record<Locale, string> = {
  en: 'English',
  ko: '한국어',
  'zh-Hant': '繁體中文',
};
